module.exports = __webpack_public_path__ + "img/market.a2e7a17d.png";